import { AssetAvailabilityReason } from '@see-power-pft-common-js/availability/asset-availability/enums/asset-availability-reason';
import { SiteAvailabilityReason } from '@see-power-pft-common-js/availability/site-availability/enums/site-availability-reason';
import {
  AvailabilityReasonDetail,
  NewAssetAvailabilityEntry,
  NewSiteAvailabilityEntry,
  PowerEnergyInput,
} from 'pages/Availability/common/FormDrawer/types';

// Base initial values with common fields
const BASE_FORM_INITIAL_VALUES = {
  start: null,
  end: null,
  startImmediately: false,
  isOpenEnded: false,
  availabilityReason: null,
  notes: '',
  isValidEntry: false,
  repeatDaily: false,
  repeatEndInclusive: null,
};

export const SITE_FORM_INITIAL_VALUES: NewSiteAvailabilityEntry = {
  ...BASE_FORM_INITIAL_VALUES,
  maxExportPower: null,
  maxImportPower: null,
  energyCapacity: null,
  siteSourceKey: '',
};

export const ASSET_FORM_INITIAL_VALUES: NewAssetAvailabilityEntry = {
  ...BASE_FORM_INITIAL_VALUES,
  selectedAssets: [],
  assetInputs: {} as Record<string, PowerEnergyInput>,
};

export const siteAvailabilityReasonDetails: AvailabilityReasonDetail[] = [
  {
    id: SiteAvailabilityReason.ASSET_FAULT_OR_OUTAGE,
    title: 'Asset fault or outage',
    description: 'Asset is malfunctioning and needs to remain off',
  },
  {
    id: SiteAvailabilityReason.OM_VISIT,
    title: 'O&M visit (Operations & Maintenance)',
    description: 'Asset health assessment or maintenance by an engineer',
  },
  {
    id: SiteAvailabilityReason.OEM_VISIT,
    title: 'OEM visit (Original Equipment Manufacturer)',
    description: 'Asset health assessment or maintenance by the manufacturer',
  },
  {
    id: SiteAvailabilityReason.DNO_CONSTRAINT,
    title: 'Grid constraint',
    description:
      'The DNO or National Grid is restricting your power and/or energy output',
  },
  {
    id: SiteAvailabilityReason.METER_LIMIT,
    title: 'Meter limit',
    description: 'Site is limited by the meter',
  },
  {
    id: SiteAvailabilityReason.PERFORMANCE_DERATING,
    title: 'Performance derating',
    description: 'Asset limits are reduced to preserve performance',
  },
  {
    id: SiteAvailabilityReason.FORCE_MAJEURE,
    title: 'Force majeure',
    description:
      'An extraordinary and unforeseen event is preventing your asset’s output',
  },
];

export const assetAvailabilityReasonDetails: AvailabilityReasonDetail[] = [
  {
    id: AssetAvailabilityReason.ASSET_FAULT_OR_OUTAGE,
    title: 'Asset fault or outage',
    description: 'Asset is malfunctioning and needs to remain off',
  },
  {
    id: AssetAvailabilityReason.OM_VISIT,
    title: 'O&M visit (Operations & Maintenance)',
    description: 'Asset health assessment or maintenance by an engineer',
  },
  {
    id: AssetAvailabilityReason.OEM_VISIT,
    title: 'OEM visit (Original Equipment Manufacturer)',
    description: 'Asset health assessment or maintenance by the manufacturer',
  },
  {
    id: AssetAvailabilityReason.DNO_CONSTRAINT,
    title: 'Grid constraint',
    description:
      'The DNO or National Grid is restricting your power and/or energy output',
  },
  {
    id: AssetAvailabilityReason.METER_LIMIT,
    title: 'Meter limit',
    description: 'Asset is limited by the meter',
  },
  {
    id: AssetAvailabilityReason.PERFORMANCE_DERATING,
    title: 'Performance derating',
    description: 'Asset limits are reduced to preserve performance',
  },
  {
    id: AssetAvailabilityReason.FORCE_MAJEURE,
    title: 'Force majeure',
    description:
      'An extraordinary and unforeseen event is preventing your asset’s output',
  },
];
